export const useTabs = (
  mdxNodes: any[],
  tabPath: string,
  hasCodeTab?: boolean,
) => {
  const tabs = mdxNodes.map((node) => {
    const content = {
      ...(node.id && { id: node.id }),
      ...(node.body && { body: node.body }),
    };

    return {
      to: `${tabPath}/${node.parent.name}`,
      name: node.parent.name,
      order: node.frontmatter?.order,
      content,
    };
  });

  // We need to splice the Code tab in, as this tab is built in code rather than
  // MDX for components eg.Avatar (but weirdly enough, not for 'subcomponents', eg.AvatarPresence).
  // This means we don't have an mdx file / mdxNode to work with here.
  // We'll always splice the Code tab in second, _unless_ a file explicitly sets
  // frontmatter order to be second. This is rare, such as in the Icon docs which
  // want to have an Icon Explorer as the first tab.
  if (hasCodeTab) {
    const codeTabIndex = tabs[1]?.order === 1 ? 2 : 1;
    tabs.splice(codeTabIndex, 0, {
      to: `${tabPath}/code`,
      name: 'code',
      order: codeTabIndex,
      content: {},
    });

    tabs.push({
      to: `${tabPath}/changelog`,
      name: 'changelog',
      order: tabs.length + 1,
      content: {},
    });
  }

  return tabs;
};

export const getCurrentTab = (path: string, mdxNodes: any[]) => {
  const pathArray = path.split('/');

  const name = pathArray[pathArray.length - 1];
  const mdx = mdxNodes.find((node) => node.parent.name === name) || mdxNodes[0];

  return { name, mdx };
};
